import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

export default function Audio({ theme, ...props }) {
  return (
    <svg
      width="22"
      height="19"
      viewBox="0 0 22 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby={props.ariaTags.labelledBy}
      aria-hidden={props.ariaTags.hidden}
      className={cx(theme.container, theme[props.svg], props.className)}
      shapeRendering="geometricPrecision"
      tabIndex={props.tabIndex}
      vectorEffect="non-scaling-stroke"
    >
      {props.title ? (
        <title id={props.ariaTags.labelledBy} lang="en">
          {props.title}
        </title>
      ) : null}
      <path
        d="M18.7479 2.2929C20.1652 4.26313 21 6.68053 21 9.2929C21 11.9053 20.1652 14.3227 18.7479 16.2929M14.7453 5.2929C15.5362 6.42673 16 7.80565 16 9.2929C16 10.7801 15.5362 12.1591 14.7453 13.2929M8.63432 1.65858L5.46863 4.82427C5.29568 4.99722 5.2092 5.08369 5.10828 5.14554C5.01881 5.20036 4.92127 5.24077 4.81923 5.26527C4.70414 5.2929 4.58185 5.2929 4.33726 5.2929H2.6C2.03995 5.2929 1.75992 5.2929 1.54601 5.40189C1.35785 5.49776 1.20487 5.65074 1.10899 5.83891C1 6.05282 1 6.33284 1 6.8929V11.6929C1 12.2529 1 12.533 1.10899 12.7469C1.20487 12.935 1.35785 13.088 1.54601 13.1839C1.75992 13.2929 2.03995 13.2929 2.6 13.2929H4.33726C4.58185 13.2929 4.70414 13.2929 4.81923 13.3205C4.92127 13.345 5.01881 13.3854 5.10828 13.4403C5.2092 13.5021 5.29568 13.5886 5.46863 13.7615L8.63431 16.9272C9.06269 17.3556 9.27688 17.5698 9.46077 17.5842C9.62033 17.5968 9.77626 17.5322 9.8802 17.4105C10 17.2702 10 16.9673 10 16.3615V2.22427C10 1.61845 10 1.31554 9.8802 1.17528C9.77626 1.05357 9.62033 0.988986 9.46077 1.00154C9.27688 1.01602 9.06269 1.2302 8.63432 1.65858Z"
        stroke="#4A4A4A"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

Audio.propTypes = {
  ariaTags: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  svg: PropTypes.string.isRequired,
  theme: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  className: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
}
